import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Box,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
} from '@material-ui/core';
import AuthorizeCheckbox from '../authorizeThird/AuthorizeCheckbox';
import LoadingButton from '../../../../../../common/LoadingButton';
import { bodyTicketProductGenerator } from '../../../../../../../helpers/tickets/TicketsHelper';
import { createTicketNoProduct } from '../../../../../../../redux/actions/TicketActions';
import { useArrivedIncompleteStyles } from './styles';

const ArrivedIncomplete = ({ ...props }) => {
  const { profile, motiveId, product, type, mobile } = props;
  const classes = useArrivedIncompleteStyles({ mobile });
  const { ticketNoProductStatus } = useSelector((state) => state.ticketReducer);
  const dispatch = useDispatch();
  const [motiveClient, setMotiveClient] = useState('');
  const [checked, setChecked] = useState(false);

  const options = [
    'Llegó el paquete sin el producto',
    'Faltan partes del producto',
  ];

  const handleOptions = (event) => {
    setMotiveClient(event.target.value);
  };

  const sendData = () => {
    const body = {
      ...bodyTicketProductGenerator({
        profile,
        type,
        motiveId,
        product,
        motiveClient: motiveClient,
      }),
    };
    dispatch(createTicketNoProduct(body));
  };

  return (
    <Box className={classes.container}>
      <Typography className={classes.titleRadio}>Elige una opción:</Typography>
      <RadioGroup onChange={handleOptions} value={motiveClient}>
        {options.map((option, index) => (
          <FormControlLabel
            key={index}
            value={option}
            label={option}
            control={<Radio color="primary" />}
            className={classes.radioButton}
            data-cy={`radio${option.split(' ').join('')}`}
          />
        ))}
      </RadioGroup>

      <AuthorizeCheckbox
        onCheck={() => setChecked(!checked)}
        idComplement="ArrivedIncomplete"
        disabled={motiveClient === ''}
      />

      <LoadingButton
        name="ArrivedIncomplete"
        text="Enviar"
        className={classes.sendButton}
        variant="contained"
        color="primary"
        loading={ticketNoProductStatus === 'loading'}
        onClick={sendData}
        disabled={!checked || motiveClient === ''}
        data-cy="ArrivedIncomplete"
      />
    </Box>
  );
};

ArrivedIncomplete.propTypes = {
  mobile: PropTypes.bool,
  motiveId: PropTypes.string,
  type: PropTypes.string,
  product: PropTypes.object,
  profile: PropTypes.object,
};

export default ArrivedIncomplete;
